import React from "react";

interface GraficButtonProps {
  onClick: () => void;
  children: React.ReactNode;
}

const GraficButton: React.FC<GraficButtonProps> = ({ onClick, children }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="rounded-full border border-[#6ea8ff]/40 bg-[#6ea8ff]/15 px-4 py-2 text-xs font-semibold text-[#6ea8ff] transition-colors hover:bg-[#6ea8ff]/25 sm:text-sm"
    >
      {children}
    </button>
  );
};

export default GraficButton;
